/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-DocumentCardTitle{padding:8px 16px;display:block;font-family:\"Segoe UI WestEuropean\",\"Segoe UI\",-apple-system,BlinkMacSystemFont,Roboto,\"Helvetica Neue\",sans-serif;-webkit-font-smoothing:antialiased;font-size:17px;font-weight:300;color:"},{"theme":"neutralPrimary","defaultValue":"#333333"},{"rawString":";height:38px;line-height:21px;overflow:hidden;word-wrap:break-word}"}]);
/* tslint:enable */
